import {useEffect, useContext} from "react";
import { searchStatus } from "../../constants/enums";
import searchIcon from "../../assets/svgs/search.svg";
import { Input, Select, Tooltip } from "antd";
import { SearchOutlined } from '@ant-design/icons';

import "./SearchInput.module.css";
import { appNotification } from "../../components/common/notification";
import { AppStateContext } from "../../state/AppProvider";

// import xDarkIcon from "../../assets/svgs/x-dark.svg"

type NotificationType = "success" | "info" | "warning" | "error";

interface Props {
  currentSearchStatus: searchStatus;
  placeholder?: string;
  conversationId?: string;
  handleSearchBtnClick: Function;
  handleSearchInputClickSmallScreen: Function;
  className: string;
  size: number;
  activeSearch: boolean;
}

export const SearchInput: React.FC<Props> = ({
  currentSearchStatus,
  placeholder,
  conversationId,
  handleSearchBtnClick,
  handleSearchInputClickSmallScreen,
  activeSearch,
  className,
  size
}) => {
  const appStateContext = useContext(AppStateContext)
  

  const onSearchBtnClick = (value: string) => {
    if (currentSearchStatus === searchStatus.Processing || currentSearchStatus == searchStatus.Inactive) {
      return;
    }
    if (!value.trim()) {
      appNotification.error({message: "Search", description: "Please enter a valid search query"});

      return;
    }
    handleSearchBtnClick(value.trim(), conversationId);
    clearSearchBox();
    handleSearchInputClickSmallScreen(false);
  };

  useEffect(() => {
    if (currentSearchStatus === searchStatus.Processing || currentSearchStatus === searchStatus.Inactive) {
      appStateContext?.dispatch({ type: 'UPDATE_SEARCH_QUERY', payload: "" } )
    }
  }, [currentSearchStatus]);

  const onSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    appStateContext?.dispatch({ type: 'UPDATE_SEARCH_QUERY', payload: e.target.value } )
  };

  const onSearchInputKeydown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSearchBtnClick(appStateContext!.state.searchInputValue);
    }
  };
  const agentSelections = (width: number = 300) => (
    <Select 
      disabled={currentSearchStatus == searchStatus.Processing || currentSearchStatus == searchStatus.Inactive || !!appStateContext?.state.currentChat}
      value={appStateContext!.state.selectedAgent?.id}
      className="embedded-select"
      style={{ width: width }} 
      options = { appStateContext?.state.agentOptions?.map((agent) => ({label: <Tooltip title={agent.name}>{agent.name}</Tooltip>, value: agent.id})) }
      size="middle"
      prefix={<div className="fs10-fw400 c-primary">Agent: </div>}
      popupMatchSelectWidth={false}
      onChange={(value) => {
        // console.log("on change value", value)
        // console.log("on change value", appStateContext?.state.agentOptions.find((agent) => agent.id === value ))
        appStateContext?.dispatch({ type: 'SET_SELECTED_AGENT', payload: appStateContext?.state.agentOptions.find((agent) => agent.id === value )!}) 
      }}
       /> 
  )
  // const onNewSessionBtnClick = () => {
  //   clearSearchBox();
  //   handleNewSessionBtnClick();
  // };

  const clearSearchBox = () => {
    appStateContext!.state.searchInputValue ="";
  };

  if (size >= 3) {
    return (
      
          <div className={`${className} d-flex d-flex-grow my-auto br-8 b-primary`}>
            <Input 
              addonBefore={agentSelections()}
              addonAfter={<SearchOutlined className="c-default" onClick={() => onSearchBtnClick(appStateContext!.state.searchInputValue)} />}
              className="w-100 fs16-fw400"
              disabled={currentSearchStatus == searchStatus.Processing || currentSearchStatus == searchStatus.Inactive}
              placeholder={currentSearchStatus == searchStatus.Inactive? "Session Ended": currentSearchStatus == searchStatus.Processing? "Loading...": placeholder}
              value={appStateContext!.state.searchInputValue}
              onChange={onSearchInputChange}
              onKeyDown={onSearchInputKeydown}
              autoComplete="off"
              size="middle"
            />
        </div>        
    );
  } else {
    return (
      <>
        {!activeSearch ? 
          (
            <div className='d-flex ms-auto' onClick={() => {handleSearchInputClickSmallScreen(true)}}>
              <img
                  className="filter-primary my-auto"
                  style={{ height: "30px", width: "auto" }}
                  src={searchIcon}
                  alt=""
                />
            </div>
          ) : (
            <div className={`${className} d-flex d-flex-grow my-auto br-8 b-primary-thin`}>
            <Input 
              addonBefore={agentSelections(100)}
              addonAfter={<SearchOutlined className="c-default" onClick={() => onSearchBtnClick(appStateContext!.state.searchInputValue)} />}
              className="w-100 fs16-fw400"
              disabled={currentSearchStatus == searchStatus.Processing || currentSearchStatus == searchStatus.Inactive}
              placeholder={currentSearchStatus == searchStatus.Inactive? "Session Ended": currentSearchStatus == searchStatus.Processing? "Loading...": placeholder}
              value={appStateContext!.state.searchInputValue}
              onChange={onSearchInputChange}
              onKeyDown={onSearchInputKeydown}
              autoComplete="off"
              size="middle"
            />
          </div>    
          )
        }
      </>
    )
  }
};
